import axios from '../library/axios'
import { MySwal } from "../library/swal";
import { setHrefWithSlugHook, } from "../config/routes/guards/slug";
import { getSlug, } from "../config/routes/guards/slug";

export const validationAccess = async (namaModule) => {
  if (!namaModule) return;
  const requestBody = {
    namaModule: namaModule,
  };
  axios({
    url: "/users/validasi-akses",
    method: "POST",
    data: requestBody,
    headers: { Authorization: `Bearer ${localStorage.getItem(`token${getSlug() ? '-' + getSlug() : ''}`)}` },
  })
    .then((res) => {
      if (res.status === 200) {
        console.log(res?.data?.message)
      }
    })
    .catch((err) => {
      if (err !== "") {
        console.log(err);
        MySwal.fire({
          icon: "error",
          title: "Oops, Error!",
          text: `${err?.response?.data?.message}`,
        });
        setTimeout(() => {
          localStorage.removeItem(`token${getSlug() ? '-' + getSlug() : ''}`);
          setHrefWithSlugHook('/login');
        }, 3000);
      }
    });
};